import { doc, getDoc, collection, setDoc, updateDoc, increment } from "firebase/firestore";
import { db } from "../../firebase-config.js";
import { getCurrentTimestamp } from "../time/getCurrentTimestamp.js";
import { notification } from 'antd';
import { findUserWhoReferedMe } from "../findUsers/findUserWhoReferedMe.js";

export const updateUserEarnings = async ({
    referringUserUid,
    buyItemPrice,
    buyItemId,
    studentUid
}) => {
    console.log("referringUserUid",referringUserUid);

    try {
        if (typeof referringUserUid !== 'string') {
            notification.error({
                message: 'Invalid referringUserUid;',
                description: `Expected string, received ${typeof referringUserUid}`,
                placement: 'topRight',
                duration: 3,
            });
            return;
        }

        const userRef = doc(db, "users", referringUserUid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
            const userData = userSnap.data();
            let yourAmount;
            if (userData.userTypes === 'team_leader') {
                // 40 percent for team leader
                yourAmount = 0.4 * Number(buyItemPrice);
            } else if (userData.userTypes === 'team_member') {
                // 20 percent for team member
                yourAmount = 0.2 * Number(buyItemPrice);
            } else {
                notification.error({
                    message: 'Invalid user type.',
                    description: `Invalid user Data type`,
                    placement: 'topRight',
                    duration: 3,
                });
                return;
            }

            // Update or create totalEarnings and totalCoins in the main user document
            // totlaCoins = 10% of yourAmount
            const totalCoins = yourAmount * 0.1;
            await updateDoc(userRef, {
                totalEarnings: increment(yourAmount),
                totalCoins: increment(totalCoins)
            });

            // Add earnings record to subcollection
            const subCollectionEarnings = collection(userRef, "earnings");
            // anurg todo : make sure orderId is unique, as may be two users can buy at the same time
            await setDoc(doc(subCollectionEarnings, `orderId-${getCurrentTimestamp()}`), {
                createdAt: getCurrentTimestamp(),
                updatedAt: getCurrentTimestamp(),
                yourAmount: yourAmount,
                buyItemId: buyItemId,
                buyItemPrice: Number(buyItemPrice),
                studentUid: studentUid,
                sellsType: "active",
                date: new Date(),
                month: new Date().getMonth() + 1, // Adding 1 because getMonth() returns 0-11
                year: new Date().getFullYear(),
            });

            // Add referral record to subcollection
            const subCollectionReferrals = collection(userRef, "referrals");
            await setDoc(doc(subCollectionReferrals, `orderId-${getCurrentTimestamp()}`), {
                createdAt: getCurrentTimestamp(),
                updatedAt: getCurrentTimestamp(),
                yourAmount: yourAmount,
                buyItemId: buyItemId,
                buyItemPrice: Number(buyItemPrice),
                studentUid: studentUid,
                referType: "active",
                date: new Date(),
                month: new Date().getMonth() + 1, // Adding 1 because getMonth() returns 0-11
                year: new Date().getFullYear(),
            });

            // this will execute only if team_member
            if (userData.userTypes === 'team_member') {
                const memberUid = userData.uid;
                const teamLeaderUid = await findUserWhoReferedMe(userData.referralId);
                console.log("Team Leader UID:", teamLeaderUid);
                console.log("Member UID:", memberUid);
                await updateTeamLeaderPassiveEarnings({
                    teamLeaderUid,
                    buyItemPrice,
                    buyItemId,
                    memberUid,
                    studentUid
                });
            }
        } else {
            notification.error({
                message: 'User does not exist.',
                description: `User not found, Contact Developer !`,
                placement: 'topRight',
                duration: 3,
            });
            return
        }
    } catch (error) {
        notification.error({
            message: "Error updating earnings",
            description: `Error : ${error.message}`,
            placement: 'topRight',
            duration: 3,
        });
        return;
    }
    return;
};

// Update team leader passive earnings
const updateTeamLeaderPassiveEarnings = async ({
    teamLeaderUid,
    buyItemPrice,
    buyItemId,
    memberUid,
    studentUid
}) => {
    console.log("Team leader",teamLeaderUid )
    try {
        if (typeof teamLeaderUid !== 'string') {
            notification.error({
                message: 'Invalid UserId;',
                description: `Expected string, received ${typeof teamLeaderUid}`,
                placement: 'topRight',
                duration: 3,
            });
            return;
        }

        const userRef = doc(db, "users", teamLeaderUid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
            const yourAmount = 0.2 * Number(buyItemPrice);;

            // Update or create totalEarnings and totalCoins in the main user document
            const totalCoins = yourAmount * 0.1;
            await updateDoc(userRef, {
                totalEarnings: increment(yourAmount),
                totalCoins: increment(totalCoins)
            });

            // Add earnings record to subcollection
            const subCollectionEarnings = collection(userRef, "earnings");

            await setDoc(doc(subCollectionEarnings, `orderId-${getCurrentTimestamp()}`), {
                createdAt: getCurrentTimestamp(),
                updatedAt: getCurrentTimestamp(),
                yourAmount: yourAmount,
                buyItemId: buyItemId,
                buyItemPrice: Number(buyItemPrice),
                studentUid: studentUid,
                memberUid: memberUid,
                referType: "passive",
                date: new Date(),
                month: new Date().getMonth() + 1, // Adding 1 because getMonth() returns 0-11
                year: new Date().getFullYear(),
            });

            // Add referral record to subcollection
            const subCollectionReferrals = collection(userRef, "referrals");
            await setDoc(doc(subCollectionReferrals, `orderId-${getCurrentTimestamp()}`), {
                createdAt: getCurrentTimestamp(),
                updatedAt: getCurrentTimestamp(),
                yourAmount: yourAmount,
                buyItemId: buyItemId,
                buyItemPrice: Number(buyItemPrice),
                studentUid: studentUid,
                memberUid: memberUid,
                referType: "passive",
                date: new Date(),
                month: new Date().getMonth() + 1, // Adding 1 because getMonth() returns 0-11
                year: new Date().getFullYear(),
            });
            notification.success({
                message: 'Congrats, New Passive Earnings!',
                description: `Team-leader passive earnings updated successfully`,
                placement: 'topRight',
                duration: 3,
            });
            return;
        } else {
            notification.error({
                message: 'User does not exist.',
                description: `Contact Developer`,
                placement: 'topRight',
                duration: 3,
            });
            return;
        }
    } catch (error) {
        notification.error({
            message: 'Error updating user earnings',
            description: `${error.message}`,
            placement: 'topRight',
            duration: 3,
        });
        return;
    }
};
